module.exports = __webpack_public_path__ + "img/Slice3.9541bf03.png";